import React from 'react';
import PropTypes from 'prop-types';
export default function H6({ props, children }) {
    return <h6 {...props}>{children}</h6>;
}
H6.propTypes = {
    children: PropTypes.node,
    props: PropTypes.any,
};
